import { render, staticRenderFns } from "./DashboardBreadcrumbs.vue?vue&type=template&id=3028cd34"
import script from "./DashboardBreadcrumbs.vue?vue&type=script&lang=ts"
export * from "./DashboardBreadcrumbs.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports